import React, { useEffect, useState } from "react";

import Image from "../../components/image";
import ProgramRating from "../../components/shared/programRating";
import { useTheme } from "../../context/ThemeContext";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import GVILogoPeopleImg from "../../images/gvi_people.svg";
import GVILogoImg from "../../images/gviIngoLogo.svg";
import ShareIcon from "../../images/icons/share-icon.inline.svg";
import { Link } from "../../utils/customLink";
import { formatCurrencyAmount } from "../../utils/formatContent";
import { flexConfig } from "../../utils/sharedDatasets";
import { shareIcons } from "../../utils/shareIcons";
import CtaButton from "../shared/buttons/ctaButton";
import CollapsibleListINGOWrapper from "../shared/collapsibleListINGOWrapper";
import ProgramCapacity from "../shared/programCapacity";
import GviFlexIconStrip from "./gviFlexIconStrip";

const NewProgramCard = ({
  program,
  featuredIncludes = [],
  openShareWithStatus,
  cardClickable,
  ctaViewLabel = "View program",
  mainContainerClass = "",
  cardbodyClass = "",
  programTitleClass = "",
  durationClass = "",
  priceClass = "",
  itemTextClass = "",
  programTypeClass = "",
  runByTextClass = "",
  extraButtonclassName = "group-hover:bg-black-lighter group-hover:border-black-lighter group-hover:text-white group-hover:shadow-sm",
  extraButtonStyle = "",
  labelClass = "",
  arrowClass = "",
  runAndLedByGVi,
  runAndLedByFlex
}) => {
  const { currentBrand, planetDomain, peopleDomain, currentSiteMeta } =
    useTheme();
  const breakpoint = useBreakpoint();

  const currencyToUse = currentSiteMeta?.currency
    ? currentSiteMeta.currency.toLowerCase()
    : process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";
  const [desc, setDesc] = useState("");

  useEffect(() => {
    setDesc(
      program?.content && program?.content?.length > 300
        ? program?.content?.substring(0, 300) + "..."
        : program?.content
    );
  }, [program]);

  const [openShareWith, setOpenShareWith] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const shareWithMediaArr = shareIcons(shareUrl);

  useEffect(() => {
    const programUri = [
      currentBrand === "people" ? peopleDomain : planetDomain,
      program.uri
    ].join("");

    setShareUrl(encodeURI(programUri));
  }, [program, currentBrand, planetDomain, peopleDomain]);

  const type = program?.acfProgramsMeta?.programTypes.map((type) => type.title);

  const programTypeSlugs = program?.acfProgramsMeta?.programTypes.map(
    (type) => type?.slug
  );

  const {
    programIngo,
    ingoFeaturedWhatsincluded,
    programHeaderSubsectionTitle
  } = program?.acfProgramsMeta ?? {};

  const filterIncludeslist = programTypeSlugs?.flatMap((type) =>
    featuredIncludes
      ?.filter((item) => item?.types?.includes(type))
      ?.flatMap((list) => list?.features)
  );

  const includes = programIngo
    ? ingoFeaturedWhatsincluded?.map((item) => ({ name: item.title }))
    : filterIncludeslist;

  const includesList = includes?.map((item, idx) => {
    return {
      name: item.name,
      useKey: `skill-key-${idx}`
    };
  });

  const duration = program?.acfProgramsMeta?.durationDisplay;

  const currentMaxPriceFilter =
    program.acfProgramsMeta?.minimumPriceFilter?.find(
      (filter) =>
        filter?.maxPriceFilterCurrencyIsoCode?.toLowerCase() === currencyToUse
    );
  const minPriceFilterAmount = programIngo
    ? currentMaxPriceFilter?.maxPriceFilterDailyAmount
    : currentMaxPriceFilter?.maxPriceFilterAmount ?? "";
  const minPrice =
    formatCurrencyAmount({
      currentSiteMeta,
      amount: minPriceFilterAmount
    }) ?? "";

  const programPopular = program?.acfProgramsMeta?.programPopular ?? false;
  const programCapacity = program?.acfProgramsMeta?.programCapacity ?? "";

  return (
    <div className={mainContainerClass}>
      {cardClickable && (
        <Link
          to={program.uri ?? program.link}
          className="h-full absolute z-20 sm:z-10 top-0 left-0 w-full right-0"
        />
      )}

      <div className="sm:w-full sm:h-80 sm:relative h-full">
        <Image
          imageClass="object-cover object-center w-full h-full md:absolute md:h-full top-0 left-0 h-72 rounded-t-md"
          sourceUrl={program?.featuredImage?.node?.sourceUrl}
          image={""}
          imageAlt=""
        />

        <div className="overflow-hidden absolute z-30 bottom-0 pr-4 pl-4 w-full">
          {type && (
            <div className="overflow-hidden">
              <span
                className={programTypeClass}
                dangerouslySetInnerHTML={{
                  __html: /journey/gi.test(type)
                    ? [type, " - NEW!"].join("")
                    : type
                }}
              />
            </div>
          )}
          <div className="flex sm:hidden p-2 bg-white rounded-tr-md justify-center items-center h-17">
            <div
              className="sm:text-base text-center text-white planet:gvi-dark-gray-text"
              dangerouslySetInnerHTML={{
                __html: program.title
              }}
            />
            {/journey/gi.test(type) && (
              <div
                className="sm:text-base italic font-light text-center text-white planet:gvi-dark-gray-text"
                dangerouslySetInnerHTML={{
                  __html:
                    programHeaderSubsectionTitle || program?.subtitle || ""
                }}
              />
            )}
          </div>
        </div>
      </div>
      <div className={cardbodyClass}>
        <div className="flex flex-row items-start justify-between w-full">
          <div
            className={`flex flex-col justify-left pb-3 ${
              openShareWithStatus ? "w-9/12" : "w-full"
            }`}
          >
            <div
              className={programTitleClass}
              dangerouslySetInnerHTML={{ __html: program.title }}
            />
            {/journey/gi.test(type) && (
              <div
                className={
                  "sm:text-base italic font-light text-white planet:gvi-dark-gray-text"
                }
                dangerouslySetInnerHTML={{
                  __html: programHeaderSubsectionTitle
                }}
              />
            )}
          </div>

          {openShareWithStatus && (
            <div className="relative flex items-center cursor-pointer justify-right">
              {!openShareWith && openShareWithStatus && (
                <ShareIcon
                  onClick={() => setOpenShareWith(!openShareWith)}
                  className={
                    "fill-black-lighter planet:fill-white hover:planet:fill-white hover:fill-black-lighter opacity-100 hover:opacity-60"
                  }
                />
              )}
              {openShareWith && (
                <div className="absolute -top-[14px] -left-[32px]">
                  <ul
                    className="flex flex-col gap-2 border border-gray-lighter rounded-xxxxl p-3 planet:bg-gray-dark bg-secondary-bg"
                    style={{
                      boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.25)"
                    }}
                  >
                    <li>
                      <ShareIcon
                        onClick={() => setOpenShareWith(!openShareWith)}
                        className={
                          "fill-black-lighter planet:fill-white hover:planet:fill-white hover:fill-black-lighter opacity-100 hover:opacity-60 w-5 h-5"
                        }
                      />
                    </li>
                    {shareWithMediaArr &&
                      shareWithMediaArr.length > 0 &&
                      shareWithMediaArr?.map((media, idx) => {
                        return <li key={idx}>{media.node}</li>;
                      })}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="hidden sm:block items-end sm:pb-5 sm:pt-0 sm:order-first">
          <ProgramRating
            outerContainerClass={"relative sm:pb-1 sm:pt-0 items-end"}
            ratingIconClass={"fill-white planet:fill-generic-text h-4"}
            ratingLogoClass={"fill-white planet:fill-gray-lighter h-4"}
            darkRatingIconClass={"block fill-white"}
            darkContainerClass={"flex gap-2 items-center"}
          />
        </div>

        <div className="divide-y border-1 border-gray-generic/30 planet:border-gray-testimonial/30" />

        <div className="flex flex-row flex-wrap gap-3 pt-4">
          {includesList?.length > 0 && (
            <CollapsibleListINGOWrapper
              listItems={includesList}
              containerClass="flex pt-3 sm:py-2 items-start sm:items-center flex-1"
              listContainerClass={"flex flex-row flex-wrap gap-2 sm:gap-2"}
              listItemClass="flex flex-row gap-1 sm:gap-2 items-center text-yellow-light planet:text-white text-xs"
              displayPlain={false}
              displayPlainCharCount={programIngo ? 100 : 150}
              breakpoint={breakpoint}
              showMore={false}
              gviFlex={programIngo}
              itemTextClass={itemTextClass}
            />
          )}
        </div>

        <div className="flex flex-col sm:flex-row w-full pt-4 sm:pt-6 items-center">
          <div className="flex sm:flex-col w-full sm:w-1/2 gap-2">
            {!programIngo && programPopular && programCapacity && (
              <ProgramCapacity
                programCapacityText={programCapacity}
                outerContainerClass={"pt-4 sm:pt-2"}
                headerClass={"text-white text-xs"}
                headerTitleClass={
                  "text-yellow-light planet:text-gray-generic text-xs"
                }
              />
            )}
            <div className="flex sm:flex-row gap-2">
              <div
                className={durationClass}
                dangerouslySetInnerHTML={{
                  __html: duration ? `Durations: ${duration}` : ""
                }}
              />
              {flexConfig?.showPricing &&
                programTypeSlugs?.includes("volunteering") &&
                minPriceFilterAmount && (
                  <>
                    <div className="divide-y height-divider mt-1 h-4 border border-gray-ingo" />
                    <div
                      className={priceClass}
                      dangerouslySetInnerHTML={{
                        __html: `From ${minPrice} ${programIngo ? "per day" : ""}`
                      }}
                    />
                  </>
                )}
            </div>
          </div>

          <div className={`flex justify-end pt-4 w-full sm:w-1/2`}>
            <CtaButton
              preset={"secondary"}
              ctaLabel={ctaViewLabel}
              to={program.uri ?? program.link}
              extraButtonclassName={extraButtonclassName}
              extraButtonStyle={extraButtonStyle}
              labelClass={labelClass}
              arrowClass={arrowClass}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProgramCard;
